import React, { Component } from "react";
import BigCalendar from "react-big-calendar";

import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-widgets/dist/css/react-widgets.css";
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Row,
  Col
} from "react-bootstrap";

import dates from "react-big-calendar/lib/utils/dates";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Modal,
  Button
} from "react-bootstrap";
import Globalize from "globalize";
import globalizeLocalizer from "react-widgets-globalize";
import { DateTimePicker } from "react-widgets";
import Header from "./header";

const axios = require("axios");

// Globalize.locale("en");

globalizeLocalizer();

const localizer = BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

class Turnos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [
        {
          start: new Date("2018-10-31 10:00:00"),
          end: new Date("2018-10-31 10:20:00"),
          title: "asdasd"
        }
      ],
      paciente: "",
      email: "",
      fechastartevent: "",
      fechaendevent: "",
      modaltitle: ""
    };
  }

  getTurnos = (date, professionalId) => {
    this.callTurnosAPI(date, professionalId)
      .then()
      .catch(err => console.log(err));
  };

  callTurnosAPI = async (date, professionalId) => {
    const response = await fetch(
      "http://190.105.227.203/turnos/turnos?professionalId=" +
        professionalId +
        "&date=" +
        date
    );
    const res = await response.json();
    //console.log(res);
    if (response.status !== 200) {
      throw Error(response.message);
    }

    var ares = Object.keys(res).map(function(key) {
      var e = res[key];
      e.start = new Date(res[key].start);
      e.end = new Date(res[key].end);
      if (res[key].title != null) {
        console.log(res[key].title);
      }
      if (res[key].available === 0) {
        e.hexColor = "lightgrey";
      } else if (res[key].title == null) {
        e.hexColor = "green";
      }
      e.title = res[key].title;
      e.status = "intialised";
      return e;
    });
    //const ares = res.map(e =>{ start:new Date({e.start}), end: new Date({e.end}) }  )};
    this.setState({ events: ares });
    //console.log(ares);
    return res;
  };

  componentDidMount() {
    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate();
    this.setState({ currentDate: date });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }
  handleSelect = ({ start, end }) => {
    // $("#foo").Modal();

    var name = "";
    var email = "";

    this.setState({
      paciente: name,
      email: email,
      fechastartevent: start,
      fechaendevent: end,
      modaltitle: "Crear Turno",

      show: true
    });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleSave = () => {
    let length = this.state.paciente.length;
    if (length === 0) return;
    length = this.state.email.length;
    if (length === 0) return;
    length = this.state.fechastartevent;
    if (length === 0) return;
    length = this.state.fechaendevent;
    if (length === 0) return;
    this.saveTurnoAPI();
    this.setState({ show: false });
  };

  saveTurnoAPI = () => {
    console.log(this.getDate(new Date(this.state.fechaendevent)));
    axios
      .post("http://190.105.227.203/turnos/saveTurnAdmin", {
        professionalId: 1,
        nombre: this.state.paciente,
        email: this.state.email,
        startdate: this.getDate(new Date(this.state.fechastartevent)),
        enddate: this.getDate(new Date(this.state.fechaendevent))
      })
      .then(response => {
        //   if (response.data.affectedRows == 1) {

        //} else {

        //}
        this.getTurnos(this.state.currentDate, this.state.professionalId);
      })
      .catch(error => {});
  };

  getDate = date => {
    var tdate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes();
    return tdate;
  };

  onNavigate = (date, view, action) => {
    console.log("#### onNavigate");
    console.log("#### date=", date);
    console.log("#### view=", view);
    var tdate =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    this.setState({ currentDate: tdate });
    this.getTurnos(tdate, this.state.professionalId);
  };

  eventStyleGetter = (event, start, end, isSelected) => {
    //console.log(event);
    var backgroundColor = event.hexColor;
    var style = {
      backgroundColor: backgroundColor,
      border: "1px solid lightgrey"
    };
    return {
      style: style
    };
  };

  showCurrentEvent = event => {
    var name = "";
    var email = "";

    if (event.title !== null) {
      name = event.title.split("-")[0];
      email = event.title.split("-")[1];
      this.setState({
        modaltitle: "Editar Turno"
      });
    } else {
      this.setState({
        modaltitle: "Crear Turno"
      });
    }
    this.setState({
      paciente: name,
      email: email,
      fechastartevent: event.start,
      fechaendevent: event.end,
      show: true
    });
  };

  getPacienteState = () => {
    const length = this.state.paciente.length;
    if (length > 0) return "success";
    else return "error";
  };

  getEmailState = () => {
    const length = this.state.email.length;
    if (length > 0) return "success";
    else return "error";
  };

  getInicioState = () => {
    const length = this.state.fechastartevent;
    if (length > 0) return "success";
    else return "error";
  };

  getFinState = () => {
    const length = this.state.fechaendevent;
    if (length > 0) return "success";
    else return "error";
  };

  onChangeProfessional = (professionalId, professionalName) => {
    console.log("onChangeProfessional " + professionalName);
    this.setState({
      professionalId: professionalId,
      professionalName: professionalName
    });
    this.getTurnos(this.state.currentDate, professionalId);
  };

  render() {
    return (
      <React.Fragment>
        <Header onChangeProfessional={this.onChangeProfessional} />
        <div
          style={{
            marginLeft: "20px",
            marginTop: "0px",
            marginRight: "20px",
            height: "100%"
          }}
        >
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.modaltitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form>
                <FormGroup
                  controlId="Paciente"
                  validationState={this.getPacienteState()}
                >
                  <ControlLabel>Paciente: </ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.paciente}
                    placeholder=""
                    onChange={e => this.setState({ paciente: e.target.value })}
                  />
                  <FormControl.Feedback />
                </FormGroup>
                <FormGroup
                  controlId="Email"
                  validationState={this.getEmailState()}
                >
                  <ControlLabel>E-mail: </ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.email}
                    placeholder=""
                    onChange={e => this.setState({ email: e.target.value })}
                  />
                  <FormControl.Feedback />
                </FormGroup>
                <FormGroup
                  controlId="Inicio"
                  validationState={this.getInicioState()}
                >
                  <ControlLabel>Inicio: </ControlLabel>
                  <DateTimePicker
                    value={this.state.fechastartevent}
                    step={20}
                    format={"dd/MM/yyyy hh:mm"}
                    onChange={value =>
                      this.setState({ fechastartevent: value })
                    }
                  />
                  <FormControl.Feedback />
                </FormGroup>
                <FormGroup controlId="Fin" validationState={this.getFinState()}>
                  <ControlLabel>Fin: </ControlLabel>
                  <DateTimePicker
                    value={this.state.fechaendevent}
                    format={"dd/MM/yyyy hh:mm"}
                    //   format={{ raw: "MMM dd, yyyy" }}
                    step={20}
                    onChange={value => this.setState({ fechaendevent: value })}
                  />
                  <FormControl.Feedback />
                </FormGroup>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleSave} type="submit" bsStyle="primary">
                Guardar Cambios
              </Button>
              <Button onClick={this.handleClose}>Close</Button>
            </Modal.Footer>
          </Modal>
          <div style={{ textAlign: "center" }}>
            <h3>{this.state.professionalName}</h3>
          </div>
          <BigCalendar
            selectable
            events={this.state.events}
            localizer={localizer}
            defaultDate={new Date()}
            defaultView={BigCalendar.Views.WEEK}
            step={20}
            timeslots={1}
            onSelectEvent={event => this.showCurrentEvent(event)}
            onSelectSlot={this.handleSelect}
            startAccessor="start"
            endAccessor="end"
            min={new Date(2017, 10, 0, 9, 0, 0)}
            max={new Date(2030, 10, 0, 19, 0, 0)}
            messages={{
              next: "Siguiente",
              previous: "Atrás",
              today: "Ahora",
              month: "Mes",
              day: "Día",
              week: "Semana"
            }}
            onNavigate={this.onNavigate}
            eventPropGetter={this.eventStyleGetter}
            style={{ height: "100hv" }}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Turnos;



// WEBPACK FOOTER //
// ./src/components/turnos.jsx